const JsonData = () => {

    const jsonOnly = {
        states: [
            { value: 1, label: 'Andaman and Nicobar Islands' },
            { value: 2, label: 'Andhra Pradesh' },
            { value: 3, label: 'Arunachal Pradesh' },
            { value: 4, label: 'Assam' },
            { value: 5, label: 'Bihar' },
            { value: 6, label: 'Chandigarh' },
            { value: 7, label: 'Chhattisgarh' },
            { value: 8, label: 'Dadra and Nagar Haveli' },
            { value: 9, label: 'Delhi' },
            { value: 10, label: 'Goa' },
            { value: 11, label: 'Gujarat' },
            { value: 12, label: 'Haryana' },
            { value: 13, label: 'Himachal Pradesh' },
            { value: 14, label: 'Jammu and Kashmir' },
            { value: 15, label: 'Jharkhand' },
            { value: 16, label: 'Karnataka' },
            { value: 17, label: 'Kerala' },
            { value: 18, label: 'Madhya Pradesh' },
            { value: 19, label: 'Maharashtra' },
            { value: 20, label: 'Manipur' },
            { value: 21, label: 'Meghalaya' },
            { value: 22, label: 'Mizoram' },
            { value: 23, label: 'Nagaland' },
            { value: 24, label: 'Odisha' },
            { value: 25, label: 'Puducherry' },
            { value: 26, label: 'Punjab' },
            { value: 27, label: 'Rajasthan' },
            { value: 28, label: 'Tamil Nadu' },
            { value: 29, label: 'Telangana' },
            { value: 30, label: 'Tripura' },
            { value: 31, label: 'Uttar Pradesh' },
            { value: 32, label: 'Uttarakhand' },
            { value: 33, label: 'West Bengal' }
        ],
        sectors: [
            {
                value: 1,
                label: "Academic",
                disabled: false
            },
            {
                value: 2,
                label: "Corporate",
                disabled: false
            },
            {
                value: 3,
                label: "Non-profit",
                disabled: false
            },
            {
                value: 4,
                label: "Startup",
                disabled: false
            },
            {
                value: 5,
                label: "Others",
                disabled: false
            },
        ],
        industry_sector: [
            {
                value: 1,
                label: "Agriculture",
                disabled: false
            },
            {
                value: 2,
                label: "Arts",
                disabled: false
            },
            {
                value: 3,
                label: "Construction",
                disabled: false
            },
            {
                value: 4,
                label: "Consumer Goods",
                disabled: false
            },
            {
                value: 5,
                label: "Corporate Services",
                disabled: false
            },
            {
                value: 6,
                label: "Design",
                disabled: false
            },
            {
                value: 7,
                label: "Education",
                disabled: false
            },
            {
                value: 8,
                label: "Energy and Mining",
                disabled: false
            },
            {
                value: 9,
                label: "Entertainment",
                disabled: false
            },
            {
                value: 10,
                label: "Finance",
                disabled: false
            },
            {
                value: 11,
                label: "Hardware and Networking",
                disabled: false
            },
            {
                value: 12,
                label: "Health Care",
                disabled: false
            },
            {
                value: 13,
                label: "Legal",
                disabled: false
            },
            {
                value: 14,
                label: "Manufacturing",
                disabled: false
            },
            {
                value: 15,
                label: "Media and Communications",
                disabled: false
            },
            {
                value: 16,
                label: "Nonprofit",
                disabled: false
            },
            {
                value: 17,
                label: "Public Administration",
                disabled: false
            },
            {
                value: 18,
                label: "Public Safety",
                disabled: false
            },
            {
                value: 19,
                label: "Real Estate",
                disabled: false
            },
            {
                value: 20,
                label: "Recreation and Travel",
                disabled: false
            },
            {
                value: 21,
                label: "Retail",
                disabled: false
            },
            {
                value: 22,
                label: "Software and IT Services",
                disabled: false
            },
            {
                value: 23,
                label: "Transportation and Logistics",
                disabled: false
            },
            {
                value: 24,
                label: "Wellness and Fitness",
                disabled: false
            },
            {
                value: 25,
                label: "Others",
                disabled: false
            },
            {
                value: 26,
                label: "Professional Services",
                disabled: false
            }
        ],
        gender: [
            {
                value: 1,
                label: "Male"
            },
            {
                value: 2,
                label: "Female"
            },
        ],
        register_job_type: [
            {
                value: 1,
                label: "Full-time"
            },
            {
                value: 2,
                label: "Part-time"
            },
            {
                value: 3,
                label: "Contract"
            },
            {
                value: 4,
                label: "Volunteer"
            }
        ],
        willing_to_relocate: [
            {
                value: 1,
                label: "Yes"
            },
            {
                value: 2,
                label: "No"
            },
        ],
        location_preference: [
            {
                value: 1,
                label: "Remote"
            },
            {
                value: 2,
                label: "Hybrid"
            },
            {
                value: 3,
                label: "In-person"
            },
        ],
        functional_specialization: [
            {
                value: 1,
                label: "Sales & Marketing",
                disabled: false
            },
            {
                value: 2,
                label: "Human Resources",
                disabled: false
            },
            {
                value: 3,
                label: "Technology & Technology Management",
                disabled: false
            },
            {
                value: 4,
                label: "Finance & Accounting",
                disabled: false
            },
            {
                value: 5,
                label: "C Suite and Board",
                disabled: false
            },
            {
                value: 6,
                label: "Academia & Research",
                disabled: false
            },
            {
                value: 7,
                label: "Life Sciences & Health Care",
                disabled: false
            },
            {
                value: 8,
                label: "Consulting & Advisory",
                disabled: false
            },
            {
                value: 9,
                label: "Logistics, Supply Chain & Operations",
                disabled: false
            },
            {
                value: 10,
                label: "Governance, Risk & Compliance",
                disabled: false
            },
            {
                value: 11,
                label: "Manufacturing, Engineering & Quality",
                disabled: false
            },
            {
                value: 12,
                label: "PR & Communications",
                disabled: false
            },
            {
                value: 13,
                label: "Project Management",
                disabled: false
            },
            {
                value: 14,
                label: "Office Management and Administration",
                disabled: false
            },
            {
                value: 15,
                label: "Facilities and Security Management",
                disabled: false
            },
            {
                value: 16,
                label: "Social Sector Development",
                disabled: false
            },
            {
                value: 17,
                label: "Sustainability & ESG",
                disabled: false
            },
            {
                value: 18,
                label: "Others",
                disabled: false
            },
        ],
        mode_of_communication: [
            {
                value: 1,
                label: "Email",
                disabled: false
            },
            {
                value: 2,
                label: "Whatsapp",
                disabled: false
            },
            {
                value: 3,
                label: "Text message",
                disabled: false
            },
            {
                value: 4,
                label: "Phone",
                disabled: false
            },
            {
                value: 5,
                label: "Others",
                disabled: false
            },
        ],
        superadmin_employe_plan_status: [{ value: "Unpaid", label: "unpaid" }, { value: "Active", label: "active" }, { value: "Canceled", label: "canceled" }, { value: "Expired", label: "expired" }],
    }

    const jsxJson = {
    }

    return {
        "jsonOnly": jsonOnly,
        "jsxJson": jsxJson
    }
}

export default JsonData